import { DataGrid, GridColDef } from "@mui/x-data-grid";
import { useEffect, useState } from "react";
import axios from "axios";
import { UserResult, UserResultsResponse } from "models/Models";
import "./Results.scss";

export const Results = () => {
  const [users, setUsers] = useState<UserResult[]>([]);
  const [year, setYear] = useState<number>();
  const [isLoading, setIsLoading] = useState<boolean>(true);

  useEffect(() => {
    //TODO:DF Local loading indicator
    axios.get<UserResultsResponse>(`${process.env.REACT_APP_API_URL}/user/results/all`).then((r) => {
      setUsers(r.data.results);
      setYear(r.data.year);
      setIsLoading(false);
    });
  }, []);

  const pointsColumnWidth = 100;

  const getPointsDisplay = (value: number | undefined, pickCount: number | undefined) => {
    if (value !== undefined && value !== null) return value;
    return (pickCount || 0) > 0 ? 0 : null;
  };

  const getPickPercentDisplay = (value: number | undefined) => {
    if (value !== undefined && value !== null) return `${Math.round(value * 100)}%`;
    return "0%";
  };

  const columns: GridColDef[] = [
    { field: "teamName", headerName: "Name", width: 150 },
    {
      field: "firstRoundPoints",
      headerName: "Round 1",
      width: pointsColumnWidth,
      type: "number",
      valueGetter: ({ value, row }) => getPointsDisplay(value, row.round1PickCount),
    },
    {
      field: "secondRoundPoints",
      headerName: "Round 2",
      width: pointsColumnWidth,
      type: "number",
      valueGetter: ({ value, row }) => getPointsDisplay(value, row.round2PickCount),
    },
    {
      field: "thirdRoundPoints",
      headerName: "Round 3",
      width: pointsColumnWidth,
      type: "number",
      valueGetter: ({ value, row }) => getPointsDisplay(value, row.round3PickCount),
    },
    {
      field: "finalRoundPoints",
      headerName: "Cup Final",
      width: pointsColumnWidth,
      type: "number",
      valueGetter: ({ value, row }) => getPointsDisplay(value, row.round4PickCount),
    },
    {
      field: "pickPercent",
      headerName: "Pick %",
      width: pointsColumnWidth,
      type: "number",
      valueGetter: ({ value }) => getPickPercentDisplay(value),
    },
    {
      field: "total",
      headerName: "Total",
      width: pointsColumnWidth,
      type: "number",
      valueGetter: ({ value, row }) => getPointsDisplay(value, row.totalPickCount),
      sortComparator: (value1, value2, cellParams1, cellParams2) => {
        const totalDiff = (Number(value1) || 0) - (Number(value2) || 0);
        if (totalDiff !== 0) return totalDiff;

        const row1 = cellParams1.api.getRow(cellParams1.id) as UserResult | null;
        const row2 = cellParams2.api.getRow(cellParams2.id) as UserResult | null;
        const pickPercent1 = row1?.pickPercent ?? 0;
        const pickPercent2 = row2?.pickPercent ?? 0;
        return pickPercent1 - pickPercent2;
      },
    },
  ];

  return (
    <div className="results-page">
      <div className="data-grid-container">
        <DataGrid
          getRowId={(c) => c.userId}
          rowHeight={30}
          hideFooter={true}
          rows={users}
          columns={columns}
          loading={isLoading}
          initialState={{
            sorting: {
              sortModel: [{ field: "total", sort: "desc" }],
            },
          }}
        />
      </div>
    </div>
  );
};
